import {ApolloLink} from "@apollo/client"
import {getGraphError} from "../../API/utils/errorHandler/getGraphError"

/** Intercepts GraphQL errors and marshals them into GraphError via getGraphError */
export const apolloErrorHandlerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((res) => {
    if (res.errors) {
      throw getGraphError(res.errors, operation.operationName)
    } else return res
  })
})
